<div class="navbar-item" [routerLink]="item.action ? null : item.path" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.matchExactPath }">
  <div class="navbar-item-logo" [class.bigger]="size === 'large'">
    <ion-icon [size]="size" [src]="item.svg" [ariaLabel]="'NavbarItemEnum.' + item.key | transloco"> </ion-icon>
    <app-badge *ngIf="item.notif" [count]="item.notif.count"></app-badge>
  </div>
  @if (!hideText) {
    <div class="navbar-item-text mt-4">{{ 'NavbarItemEnum.' + item.key | transloco }}</div>
  }
</div>
